import useDispatcher from './useDispatcher';
import { AT } from '../actions/actionTypes';
import Logger from '../libs/logger'; import { LogArea } from '../libs/logger/const';

export const useModal = () => {
  const { doAction } = useDispatcher();

  const setModal = (dialogId = '') => {
    Logger.info(['setModal', dialogId], LogArea.Redux); 
    doAction<string>(AT.MODAL_ACTIVE_CHANGED, dialogId)
  };

  return {
    setModal
  };
};

export default useModal;
